import { AddButton } from '@/common/buttons/AddButton';
import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { StringUtils } from '@/common/utils/StringUtils';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useCallback, useState } from 'react';

export const ProdRelList = ({ ndc11ProdId }) => {
  // This mode tracks this Ndc11's status as the Parent or Child of the relationships
  // Hence, the Tab names will be opposite of the mode
  const [mode, setMode] = useState('parent');

  const handleChange = (event, newMode) => {
    if (newMode !== null) {
      setMode(newMode);
    }
  };

  const augRowsReq = useCallback(
    (rowsReq) => {
      if (!ndc11ProdId) return;
      const addlExpr = ExprUtils.whereParams(mode + 'ProdId', ndc11ProdId);
      rowsReq.expr = ExprUtils.and(rowsReq.expr, addlExpr);
    },
    [ndc11ProdId, mode],
  );

  const augFieldDefs = (fieldToFieldDef) => {
    const productFieldDef = fieldToFieldDef.parentProdId ?? fieldToFieldDef.childProdId;
    fieldToFieldDef.parentProdId = {
      ...productFieldDef,
      field: 'parentProdId',
      displayName: 'Parent Product',
    };
    fieldToFieldDef.childProdId = {
      ...productFieldDef,
      field: 'childProdId',
      displayName: 'Child Product',
    };
  };

  // Augment nav FK's to match ProdRel entity Parent / Child
  const augNavEntityObj = (navEntityObj) => {
    Object.keys(navEntityObj).forEach((key) => {
      navEntityObj[mode + StringUtils.capitalizeFirstLetter(key.substring(5))] = navEntityObj[key];
      delete navEntityObj[key];
    });
  };

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons);
    tabButtons.push(
      // TODO: Confusing that the Children button has a value and id of parent and vice versa for Parents button
      <ToggleButtonGroup value={mode} exclusive onChange={handleChange}>
        <ToggleButton value="parent" aria-label="Children">
          Children
        </ToggleButton>
        <ToggleButton value="child" aria-label="Parents">
          Parents
        </ToggleButton>
      </ToggleButtonGroup>,

      <AddButton entity="PROD_REL" augNavEntityObj={augNavEntityObj}></AddButton>,
    );
  };

  return (
    <EntityList entity="PROD_REL" augTabButtons={augTabButtons} augFieldDefs={augFieldDefs} augRowsReq={augRowsReq} />
  );
};
